import { render } from "./attribute_xx_set.vue?vue&type=template&id=2df0fe3f&scoped=true"
import script from "./attribute_xx_set.vue?vue&type=script&lang=js"
export * from "./attribute_xx_set.vue?vue&type=script&lang=js"

import "./attribute_xx_set.vue?vue&type=style&index=0&id=2df0fe3f&scoped=true&lang=css"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df0fe3f"]])

export default __exports__